module.exports = __webpack_public_path__ + "img/14-1.4c8b50c7.jpg";